/*
 * Where: src/features/top/components/SupportPreviewSection.js
 * What: Intro flow and value cards for top page.
 * Why: Group top-page domain sections in one feature component.
 */
import React from 'react';
import InfoCard from '../../../components/molecules/InfoCard';

function SupportPreviewSection({ valuePoints, introFlow }) {
    return (
        <section className="section-block">
            <h2>サービス概要</h2>
            <div className="card-grid">
                {valuePoints.map((point) => (
                    <InfoCard key={point.title} title={point.title} text={point.text} />
                ))}
            </div>
            <div className="flow-panel">
                <h3>処理フロー</h3>
                <ol>
                    {introFlow.map((flow) => (
                        <li key={flow}>{flow}</li>
                    ))}
                </ol>
            </div>
        </section>
    );
}

export default SupportPreviewSection;
